import React from "react";
import { View, StyleSheet } from "react-native";
import { DownloadIcon, FileIcon } from "@phosphor-icons/react";

import CustomText from "../../../../common/general/CustomText/CustomText";
import CustomButton from "../../../../common/general/CustomButton/CustomButton";
import useFileFetch from "../../../../../hooks/useFileFetch";
import { File } from "@axio/graphql/generated/graphql";

interface FileSubmissionItemProps {
  file: Partial<File>;
}

const FileSubmissionItem: React.FC<FileSubmissionItemProps> = ({ file }) => {
  const { fetchAndOpenFile } = useFileFetch();

  return (
    <View style={styles.submissionContainer}>
      <View style={styles.submissionFileItem}>
        <View style={styles.fileIcon}>
          <FileIcon size={24} color="#DC2626" />
        </View>
        <View style={styles.fileDetails}>
          <CustomText text={file.fileName} size="s" weight="bold" useTranslationText={false} />
        </View>
        <View style={styles.fileActions}>
          <CustomButton
            text="Download"
            leftIcon={<DownloadIcon size={14} color="#3E68FE" />}
            textStyle={styles.fileButtonText}
            size="s"
            styleType="lightStroke"
            onPress={() => fetchAndOpenFile(file.fileURL)}
          />
        </View>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  submissionContainer: {
    borderWidth: 1,
    borderColor: "#E5E7EB",
    borderRadius: 12,
    padding: 20,
    backgroundColor: "#FCFCFC",
  },
  submissionFileItem: {
    flexDirection: "row",
    alignItems: "center",
    gap: 16,
    paddingVertical: 12,
  },
  fileIcon: {
    width: 48,
    height: 48,
    borderRadius: 10,
    backgroundColor: "#FEE2E2",
    justifyContent: "center",
    alignItems: "center",
  },
  fileDetails: {
    flex: 1,
  },
  fileActions: {
    flexDirection: "row",
    gap: 8,
  },
  fileButtonText: {
    color: "#3E68FE",
  },
});

export default FileSubmissionItem;
